var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.loading)?void 0:_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v(_vm._s(_vm.instruction.name))])]),_c('v-col',{attrs:{"cols":"12"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.instruction.content)}})])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }